<template>
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="accent" dark class="title" flat>
      <v-icon left>fas fa-church</v-icon>
      Mount Forms:
    </v-toolbar>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="subtitle-1">
          Here you will find a myriad of forms accessible to those both inside and outside The Mount congregation. If you cannot locate the form you are searching for please <router-link to="/Contact" class="accent--text">Contact</router-link> The Mount office.
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4" offset-sm="8" class="subtitle-1 text-center text-sm-right">
          <v-select 
            label="Filter by Category:" :items="categories" item-color="accent" 
            clearable color="secondary" outlined 
            v-model="categoryFilter" @click:clear="$nextTick(() => categoryFilter='')"
          ></v-select>
        </v-col>
      </v-row>
      <v-row no-gutters class="ma-1 submissions subtitle-1" style="cursor:pointer" v-for="item in filteredResults" :key="item.id" @click="openLink(item)">
          <v-col cols="12" sm="8" class="text-center text-sm-left">{{item.item}}</v-col>
          <v-col cols="12" sm="4" class="text-center">{{item.category}}</v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    data(){
      return {
        categories      : ["Admin", "Financial", "Kids at The Mount", "Missions", "Students at The Mount"],
        categoryFilter  : ""
      }
    },
    methods: {
      openLink(item){
        window.open(item.value)
      }
    },
    computed: {
      filteredResults(){
        if (this.categoryFilter == ""){
          return this.getSettings
        }
        else {
          return this.getSettings.filter(item => item.category == this.categoryFilter)
        }
      },
      getSettings(){
        return this.$store.getters.getSettings.filter(item => {
          return item.category != "App"
        })
      }
    }
  }
</script>

<style scoped>
.submissions:nth-child(odd){
  background: #CCC;
}
.submissions:hover{
  background: #A4B884
}
</style>